import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'gatsby';
import '../sass/header.scss';
import { StaticImage } from 'gatsby-plugin-image';
import { buildUrl, useCcParam } from '../utils/navigation';

const Header = () => {
  const ccParam = useCcParam();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close menu when clicking on overlay (mobile only)
  const handleOverlayClick = () => {
    if (isMobile) {
      closeMenu();
    }
  };

  // Close menu when clicking on menu links
  const handleMenuLinkClick = () => {
    closeMenu();
  };

  // Check if device is mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  // Close menu on escape key and click outside
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeMenu();
      }
    };

    const handleClickOutside = (event: MouseEvent) => {
      if (isMenuOpen && !isMobile && headerRef.current && !headerRef.current.contains(event.target as Node)) {
        closeMenu();
      }
    };

    if (isMenuOpen) {
      document.addEventListener('keydown', handleEscapeKey);
      document.addEventListener('mousedown', handleClickOutside);
      // Prevent body scroll when menu is open on mobile
      if (isMobile) {
        document.body.style.overflow = 'hidden';
      }
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen, isMobile]);

  return (
    <div className="site-header" ref={headerRef}>
      <div className="site-header__logo-section">
        <Link to={buildUrl('/', ccParam)} className="site-header__logo-link">
          <StaticImage 
            src="../images/logoBlanco.png" 
            alt="Logitech" 
            className="site-header__logo"
          />
        </Link>
      </div>
      
      <button 
        className={`site-header__menu-toggle ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
        aria-expanded={isMenuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`site-header__menu ${isMenuOpen ? 'active' : ''}`}>
        <nav>
          <ul>
            <li><Link to={buildUrl('/sections/?section=gaming-racing', ccParam)} onClick={handleMenuLinkClick}>Regala Velocidad</Link></li>
            <li><Link to={buildUrl('/sections/?section=gaming-core', ccParam)} onClick={handleMenuLinkClick}>Regala Máximo Rendimiento</Link></li>
            <li><Link to={buildUrl('/sections/?section=gaming-pro', ccParam)} onClick={handleMenuLinkClick}>Regala Juego Profesional</Link></li>
            <li><Link to={buildUrl('/sections/?section=gaming-console', ccParam)} onClick={handleMenuLinkClick}>Regala Entretenimiento</Link></li>
            <li><Link to={buildUrl('/sections/?section=mx', ccParam)} onClick={handleMenuLinkClick}>Regala Rendimiento Avanzado</Link></li>
            <li><Link to={buildUrl('/sections/?section=ergo', ccParam)} onClick={handleMenuLinkClick}>Regala Bienestar</Link></li>
            <li><Link to={buildUrl('/sections/?section=pop-icon', ccParam)} onClick={handleMenuLinkClick}>Regala Estilo</Link></li>
            <li><Link to={buildUrl('/sections/?section=ue', ccParam)} onClick={handleMenuLinkClick}>Regala Música</Link></li>
          </ul>
        </nav>
      </div>

      {isMenuOpen && isMobile && (
        <div 
          className="site-header__overlay active"
          onClick={handleOverlayClick}
        />
      )}
    </div>
  );
};

export default Header;
